import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Modal, message } from 'antd';
import Type from '@actionTypes';
import {
  ORIGINALEVIDENCE,
  LITIGATIONLEGALDOC,
  EXECUTIONLEGALDOC,
  LITIPRSVLEGALDOC,
  MEDIATIONLEGALDOC
} from '@utils/constant'
import SuccessModal from '@components/ModalContent/successModal'
import { SignatureModal } from '@components/SignatureModal'
import ElectronicDossierDetail from './electronicDossierDetail'
import toAll from '../../../images/icon_toAll.png';
import toMin from '../../../images/icon_toMin.png';
import ConfirmPdf from "./confirmPdf";


// 电子卷宗
const ElectronicDossier = (props) => {
  const { path, systemNum, cardPath } = props
  const dispatch = useDispatch()
  const [ShowPDF, setShowPDF] = useState({ isShowPDF: false, pdfType: 0, record: '' });
  const [showCode, setShowCode] = useState(false);
  const [checkData, setCheckData] = useState({})
  const [visible, setVisible] = useState(false)
  const [successVisible, setSuccessVisible] = useState(false)
  const [resId, setResId] = useState("");
  const { baseUrl } = useSelector(state => state.app)

  const getDoc = () => {
    dispatch({ type: Type.GET_DETAIL, path, systemNum, cardType: `${cardPath}/${ORIGINALEVIDENCE}` })
    dispatch({ type: Type.GET_DETAIL, path, systemNum, cardType: `${cardPath}/${LITIGATIONLEGALDOC}` })
    dispatch({ type: Type.GET_DETAIL, path, systemNum, cardType: `${cardPath}/${EXECUTIONLEGALDOC}` })
    dispatch({ type: Type.GET_DETAIL, path, systemNum, cardType: `${cardPath}/${LITIPRSVLEGALDOC}` })
    dispatch({ type: Type.GET_DETAIL, path, systemNum, cardType: `${cardPath}/${MEDIATIONLEGALDOC}` })
  };

  const handleCheck = () => {
    // console.log(checkData);
    if (checkData.status === 0) {
      message.warning('请选择审核结果');
      return;
    }
    if (checkData.status === 2 && checkData.reason === '') {
      message.warning('若审核不通过,请输入理由');
      return;
    }
    dispatch({
      type: Type.GET_CHECKRES,
      params: checkData,
      path: props.path + '/elecDossier',
      resID: checkData.resID,
      cb: () => {
        setVisible(false)
        setSuccessVisible(true)
      }
    });
  }

  const signature = (id, sign) => {
    let resID = id;
    if (id) {
      setResId(id);
      resID = id;
    } else {
      resID = resId;
    }
    dispatch({
      type: Type.GET_SIGNATURE,
      resID,
      systemNum,
      sign,
      cb: () => setShowCode(true)
    });
  };

  const openCheckModal = () => {
    const { record = {} } = ShowPDF
    setCheckData({ resID: record?.resID, status: record?.checkStatus, reason: record?.checkRefuseReason } || {})
    setVisible(true)
  }

  return (
    <>
      <div className="detail-card-title">电子卷宗
        {ShowPDF.isShowPDF ? (
          <div className="detail-btn">
            {ShowPDF.pdfType === 1 && (
              <Button type="primary" name="confirmPDF" onClick={openCheckModal}>
                审核
              </Button>
            )}
            <Button
              type="default"
              onClick={() => {
                ShowPDF.pdfType === 1 && getDoc()
                setShowPDF({ isShowPDF: false, pdfType: 2 });
              }}
            >
              返回
            </Button>
          </div>
        ) : ""}
        <img className='all-icon' src={props.whoAll === 'R' ? toMin : toAll} alt=''
             onClick={() => props.handleScreen('R')}/>
      </div>
      <div className='detail-card-content'>
        <ElectronicDossierDetail
          isShowPDF={ShowPDF.isShowPDF}
          showPDF={setShowPDF}
          systemNum={props.systemNum}
          path={props.path}
          cardPath={props.cardPath}
          permChildren={props.permChildren}
          getDoc={getDoc}
          showCode={setShowCode}
          signature={signature}
        />
      </div>
      <Modal
        destroyOnClose={true}
        visible={visible}
        closable={false}
        onOk={handleCheck}
        onCancel={() => setVisible(false)}
        okText="确定"
        cancelText="取消"
      >
        <ConfirmPdf setCheckData={setCheckData} data={checkData}/>
      </Modal>
      <SuccessModal visible={successVisible} msg="提交成功" handleCancel={() => setSuccessVisible(false)}/>
      <SignatureModal
        showCode={showCode}
        baseUrl={baseUrl}
        onCancel={() => setShowCode(false)}
        onSubmit={signature}
      />
    </>
  );
};

export default ElectronicDossier;
